// extracted by mini-css-extract-plugin
export var container = "_s0-0";
export var table = "_s0-2";
export var tableWrapper = "_s0-1";